import React, { useState, useEffect } from "react";
import { StyledEngineProvider, ThemeProvider, CssBaseline } from "@mui/material";
import { createCustomTheme } from "./types.js";
const CustomThemeProvider = ({ children, locale }) => {
  const [theme, setTheme] = useState(createCustomTheme(locale));
  useEffect(() => {
    setTheme(createCustomTheme(locale));
  }, [locale]);
  return /* @__PURE__ */ React.createElement(StyledEngineProvider, { injectFirst: true }, /* @__PURE__ */ React.createElement(ThemeProvider, { theme }, /* @__PURE__ */ React.createElement(CssBaseline, null), children));
};
export {
  CustomThemeProvider
};
//# sourceMappingURL=ThemeProvider.js.map
